import { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { doc, getDoc, addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import ChatRoom from "./ChatRoom";

export default function ChatRoomWrapper() {
  const { chatId } = useParams();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [otherUser, setOtherUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();

  // Ref para evitar enviar mensaje automático más de una vez
  const hasSentAutoMessage = useRef(false);

  // Obtener usuario del chat
  useEffect(() => {
    const fetchOtherUser = async () => {
      try {
        if (!chatId || !currentUser?.uid) return;

        const [id1, id2] = chatId.split("_");

        // ── Verificación de acceso ──────────────────────────────────────────
        // El chatId está formado por dos UIDs separados por "_".
        // Si el usuario actual no es ninguno de los dos, no tiene acceso.
        if (currentUser.uid !== id1 && currentUser.uid !== id2) {
          console.warn("[ChatRoomWrapperVol2] Acceso denegado: usuario no es participante.");
          navigate("/", { replace: true });
          return;
        }

        const otherUserId = id1 === currentUser.uid ? id2 : id1;

        const userDoc = await getDoc(doc(db, "users", otherUserId));
        if (userDoc.exists()) {
          setOtherUser({ uid: otherUserId, ...userDoc.data() });
        } else {
          console.warn("Usuario no encontrado");
        }
      } catch (err) {
        console.error("Error obteniendo datos del usuario:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOtherUser();
  }, [chatId, currentUser]);

  // Enviar mensaje automático si existe el query param
  useEffect(() => {
    const sendAutoMessage = async () => {
      if (!currentUser || !chatId) return;

      const autoMessage = searchParams.get("autoMessage");
      if (!autoMessage) return;

      // Evitar enviar más de una vez
      if (hasSentAutoMessage.current) return;
      hasSentAutoMessage.current = true;

      try {
        const messagesRef = collection(db, "chats", chatId, "messages");
        await addDoc(messagesRef, {
          text: decodeURIComponent(autoMessage),
          sender: currentUser.uid,
          createdAt: serverTimestamp(),
          read: false,
          attachments: [],
        });

        // Opcional: limpiar query param para evitar reenvío al recargar
        // window.history.replaceState(null, "", window.location.pathname);
      } catch (error) {
        console.error("Error enviando mensaje automático:", error);
      }
    };

    sendAutoMessage();
  }, [chatId, currentUser, searchParams]);

  if (loading) {
    return (
      <div className="p-4 text-gray-600 dark:text-gray-300 text-center">
        Cargando usuario...
      </div>
    );
  }

  if (!otherUser) {
    return (
      <div className="p-4 text-red-600 text-center">
        Usuario no encontrado.
      </div>
    );
  }

  return <ChatRoom otherUser={otherUser} onBack={() => navigate(-1)} />;
}